import { useContext } from "react";
import { AvisContext } from "../../context";
import { AvisPageTitle } from "../form";
import { AvisDescriptiveText } from "../form/AvisDescriptiveText";
import { LandingPageActions } from "./LandingPageActions";

interface ILandingPageProps {
  title: string;
  textKey: string;
  conditionalTextKeys?: string[];
  children?: React.ReactNode;
}
export function LandingPage(props: Readonly<ILandingPageProps>) {
  const { title, textKey, conditionalTextKeys, children } = props;
  const { res } = useContext(AvisContext);
  return (
    <div className="avis-landing-page">
      <AvisPageTitle title={res("label_LandingPage")} />
      <div className="avis-primary-h1 avis-uppercase">{title}</div>
      <AvisDescriptiveText className="title-description" textKey={textKey} />
      {conditionalTextKeys?.map((cKey) => (
        <AvisDescriptiveText
          key={cKey}
          className="title-description"
          textKey={cKey}
        />
      ))}
      <LandingPageActions>{children}</LandingPageActions>
    </div>
  );
}
